import { render, staticRenderFns } from "./divide-class.vue?vue&type=template&id=67d94a67&"
import script from "./divide-class.vue?vue&type=script&lang=js&"
export * from "./divide-class.vue?vue&type=script&lang=js&"
import style0 from "./divide-class.vue?vue&type=style&index=0&id=67d94a67&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports